import { useQuery } from "@tanstack/react-query";
import type { Period } from "./client";
import { dashboardApi } from "./client";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  analytics: (period: string) => ["dashboard", "analytics", period] as const,
};

export function useDashboardAnalyticsQuery(period: Period = "week") {
  return useQuery({
    queryKey: dashboardKeys.analytics(period),
    queryFn: () => dashboardApi.getAnalytics(period),
  });
}
